module.exports = __webpack_public_path__ + "img/193.fixed_paper_dispenser.93bd7982.svg";